import { render } from "./ProviderForm.vue?vue&type=template&id=066bb528&scoped=true"
import script from "./ProviderForm.vue?vue&type=script&lang=js"
export * from "./ProviderForm.vue?vue&type=script&lang=js"

import "./ProviderForm.vue?vue&type=style&index=0&id=066bb528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066bb528"]])

export default __exports__